import { TopicApiModel, TopicType } from '../api/topics.api';

export interface TopicViewModel {
    id: number;
    type: TopicType;
    name: string;
    description: string;
    message?: string;
    enabled: boolean;
}

const isTopicEnabled = (
    topicApiModel: TopicApiModel,
    isFieldProEnabled: boolean,
    isFieldProCoachingEnabled: boolean
): boolean => {
    switch (topicApiModel.type) {
        case TopicType.InformationInServiceTitan:
            return true;
        // Field Pro Coaching has its own entitlement, checked against the salespro-web microservice.
        case TopicType.FieldProCoaching:
            return isFieldProCoachingEnabled;
        // Equipment / Troubleshooting remain gated on the legacy Field Assist Pro entitlement.
        default:
            return isFieldProEnabled;
    }
};

export const toTopicViewModel = (
    topicApiModel: TopicApiModel,
    isFieldProEnabled: boolean,
    isFieldProCoachingEnabled: boolean
): TopicViewModel => {
    return {
        description: topicApiModel.description,
        enabled: isTopicEnabled(topicApiModel, isFieldProEnabled, isFieldProCoachingEnabled),
        id: topicApiModel.id,
        message: topicApiModel.message,
        name: topicApiModel.name,
        type: topicApiModel.type,
    };
};
